import { root, id } from './permissions';

export const permissions = {
  ...root,
  id,
};
